var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

  // START VIDEO

// $(document).ready(function(){
// var video1 = document.getElementById("our_Video");
// video1.currentTime = 0;
// $(".mute-bt").click(function(){
//      if($(this).hasClass("stop"))
//      {
//          var our_Video = document.getElementById("our_Video");
//          $("#our_Video").prop('muted', false);
//          $(this).removeClass("stop");
//      }
//      else{
//          var our_Video = document.getElementById("our_Video");
//          $("#our_Video").prop('muted', true);
//          $(this).addClass("stop");
//      }
//  });
 
//  $(".play-bt").click(function(){
//      $(".play-bt").hide();
//      $(".pause-bt").show();
//      var our_Video = document.getElementById("our_Video");
//      if($(".stop-bt").hasClass("active")){
//          our_Video.currentTime = 0;
//      }
//      our_Video.play();                                         
//  });
//  $(".pause-bt").click(function(){
//      $(".play-bt").show();
//      $(".pause-bt").hide();
//      $(".pause-bt").addClass("active");
//      $(".stop-bt").removeClass("active");
//      var our_Video = document.getElementById("our_Video");
//      our_Video.pause();                                         
//  });
//  $(".stop-bt").click(function(){
//      $(".play-bt").show();
//      $(".pause-bt").hide();
//      $(".pause-bt").removeClass("active");
//      $(".stop-bt").addClass("active");
//      var our_Video = document.getElementById("our_Video");
//      stop
//      our_Video.pause();                                         
//  });
// });	 




$(document).ready(function() {
            var video1 = document.getElementById("our_Video");
            video1.currentTime = 0;
            video1.muted = true; // Ensure video is muted by default
            $(".mute-bt").addClass("stop"); // Add stop class initially

            $(".mute-bt").click(function() {
                if ($(this).hasClass("stop")) {
                    $("#our_Video").prop('muted', false);
                    $(this).removeClass("stop");
                } else {
                    $("#our_Video").prop('muted', true);
                    $(this).addClass("stop");
                }
            });

            $(".play-bt").click(function() {
                $(".play-bt").hide();
                $(".pause-bt").show();
                if ($(".stop-bt").hasClass("active")) {
                    video1.currentTime = 0;
                }
                video1.play();
            });

            $(".pause-bt").click(function() {
                $(".play-bt").show();
                $(".pause-bt").hide();
                $(".pause-bt").addClass("active");
                $(".stop-bt").removeClass("active");
                video1.pause();
            });

            $(".stop-bt").click(function() {
                $(".play-bt").show();
                $(".pause-bt").hide();
                $(".pause-bt").removeClass("active");
                $(".stop-bt").addClass("active");
                video1.pause();
            });
        });